import './index.html'
import './404.html'
import '@myob/myob-styles/dist/styles/myob.css'
import 'es6-shim'
import '../styles/main.scss'
import '../images/favicon.ico'

import React from 'react'
import Routing from './routing'
import { render } from 'react-dom'
import { Provider } from 'react-redux'

import createStore from './create-store'

const store = createStore()

render((
  <Provider store={store}>
    <Routing />
  </Provider>
), document.getElementById('app'));



// WEBPACK FOOTER //
// ./src/app/index.js